import React from "react";
import * as Yup from "yup";
import yupSchema from "../../../constants/schema";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import currenciesService from "../../../services/currencies.service";

const initialValues = {
  name: "",
  code: "",
  basePrice: 0,
};

const schema = Yup.object().shape({
  name: yupSchema.name,
  basePrice: Yup.number().min(0).required(),
});

export default function FormModalContent({ close, data }) {
  const errorHandler = useErrorHandler();

  const form = [
    {
      _type: "textField",
      name: "name",
      label: "نام",
      autoFocus: true,
    },
    {
      _type: "textField",
      name: "code",
      label: "کد ارز",
    },
    {
      _type: "textField",
      name: "basePrice",
      type: "currency",
      label: "قیمت مبنا به تومان",
      inputProps: {
        min: 0,
      },
    },
  ];

  const handleSubmit = async (model, { setSubmitting }) => {
    let op;
    if (data?.id) {
      op = await currenciesService.editCurrency(data.id, model);
    } else {
      op = await currenciesService.createCurrency(model);
    }

    const { error } = op;
    setSubmitting(false);
    if (error) return errorHandler(error);

    close(true);
  };

  return (
    <DialogFormBuilder
      {...{
        close,
        name: "ارز",
        data,
        schema,
        initialValues,
        handleSubmit,
        form,
      }}
    />
  );
}
